// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon___tNY7e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FollowSeller/FollowSellerButton.scss
// module id = lArx
// module chunks = 57